<template>
	<div class="dsp-box">
		<!-- 空状态：加载完成且无数据时显示 -->
		<kong v-if="loaded && list.length === 0"></kong>
		<!-- 视频上下滑动容器 -->
		<div class="dsp-swiper" :class="{ 'dsp-swiper--narrow': showComment }" ref="swiper" v-show="list.length > 0" @scroll="handleScroll" @wheel="handleWheel" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd" @mousedown="handleDragDown" @contextmenu.prevent>
			<div class="dsp-swiper-item" v-for="(item,index) in list" :key="item.id || index">
				<!-- 视频画面区域（不含底部控制条） -->
				<div class="dsp-video-wrap">
					<!-- 视频背后的虚化封面图：竖屏视频两侧留白区域显示 -->
					<img class="dsp-video-bg" v-if="item.coverUrl" :src="item.coverUrl" />
					<!-- 暂停时显示的播放按钮（纯视觉，点击穿透到视频）；离开页面或翻页动画期间不显示，避免相邻被暂停的视频闪出按钮 -->
					<img class="dsp-play-btn" v-if="!item.playing && !leaving && !isWheelLock && !isDragging && !isTouching && !snapAnimating" :src="spBf" />
					<!-- 缓冲加载指示：当前视频因网络卡顿等待数据时显示 -->
					<div class="dsp-loading" v-if="index === currentIndex && item.buffering"></div>
					<!-- 全屏按钮：仅对当前视频显示；已全屏时显示退出图标 -->
					<div class="dsp-fullscreen-btn" v-if="index === currentIndex && !leaving" @click.stop="toggleFullscreen">
						<svg v-if="!isFullscreen" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>
						</svg>
						<svg v-else viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5"/>
						</svg>
					</div>
					<video
						class="dsp-video"
						:ref="'video' + index"
						:src="videoSrc(item, index)"
						:poster="item.coverUrl || ''"
						loop
						playsinline
						webkit-playsinline
						preload="auto"
						@click="handleVideoClick(index)"
						@dblclick="handleVideoDblClick(item)"
						@timeupdate="onTimeUpdate(index)"
						@loadedmetadata="onLoadedMetadata(index)"
						@play="onVideoPlay(index)"
						@pause="onVideoPause(index)"
						@waiting="onVideoWaiting(index)"
						@playing="onVideoPlaying(index)"
						@canplay="onVideoCanPlay(index)"
					></video>
				</div>
				<!-- 底部信息：@用户名 + 标题 -->
				<div class="dsp-info">
					<span class="dsp-info-user">{{ item.nickName }}</span>
					<span class="dsp-info-title">{{ item.title || '' }}</span>
				</div>
				<!-- 右侧操作栏：头像 / 点赞 / 评论 / 收藏 -->
				<div class="dsp-actions">
					<div class="dsp-actions-item">
						<img class="dsp-actions-avatar" :src="item.headPortrait" @click.stop="handleGoUserHome(item)" />
					</div>
					<div class="actions">
						<div class="dsp-actions-item" @click.stop="handleToggleLike(item)">
							<img class="dsp-actions-icon" :src="item.isGiveLike === 1 ? spDz2 : spDz1" />
							<span class="dsp-actions-count">{{ item.giveLikeNumber || 0 }}</span>
						</div>
						<div class="dsp-actions-item" @click.stop="handleShowComment(item)" v-if="item.commentStatus == 1">
							<img class="dsp-actions-icon" :src="spPinglun" />
							<span class="dsp-actions-count">{{ item.commentNumber || 0 }}</span>
						</div>
						<div class="dsp-actions-item" @click.stop="handleToggleCollect(item)">
							<img class="dsp-actions-icon" :src="item.isCollect === 1 ? spShoucang2 : spShoucang1" />
							<span class="dsp-actions-count">{{ item.collectNumber || 0 }}</span>
						</div>
					</div>
				</div>
				<!-- 播放进度条：点击/拖动可跳转播放 -->
				<div class="dsp-progress" @mousedown.stop="handleProgressDown($event, index)">
					<div class="dsp-progress-track">
						<div class="dsp-progress-fill" :style="{ width: progressPercent(item) + '%' }"></div>
					</div>
				</div>
				<!-- 底部控制条 -->
				<div class="dsp-controls">
					<div class="dsp-controls-btn" @click.stop="togglePlay(index)">
						<svg v-if="item.playing" viewBox="0 0 24 24" width="18" height="18">
							<path d="M7 5h3.4v14H7zM13.6 5H17v14h-3.4z" fill="#FFFFFF"/>
						</svg>
						<svg v-else viewBox="0 0 24 24" width="18" height="18">
							<path d="M8 5l11 7-11 7V5z" fill="#FFFFFF"/>
						</svg>
					</div>
					<span class="dsp-controls-time">{{ formatTime(item.pTime) }} / {{ formatTime(item.dTime) }}</span>
					<!-- 内嵌评论输入：直接在底部控制条发表评论 -->
					<div class="dsp-controls-input" @mousedown.stop @click.stop>
						<div class="dsp-bar-emoji-btn" @click.stop="toggleBarEmoji">
							<div class="dsp-bar-emoji-face" :class="{ 'dsp-bar-emoji-face--active': barEmojiShow }"></div>
						</div>
						<input class="dsp-controls-field" v-model="barInput" :placeholder="$t('all.shuodianshenme')" @keydown.enter.prevent="submitBarComment" />
						<div class="dsp-controls-send" :class="{ 'dsp-controls-send--loading': barSubmitting }" @click.stop="submitBarComment">{{ $t('all.fabiao') }}</div>
					</div>
					<div class="dsp-controls-btn" @click.stop="toggleMute(index)">
						<svg viewBox="0 0 24 24" width="18" height="18">
							<path d="M4 9v6h4l5 4V5L8 9H4z" fill="#FFFFFF"/>
							<path v-if="!muted" d="M16.5 8.5a5 5 0 010 7M18.5 6a8 8 0 010 12" stroke="#FFFFFF" stroke-width="1.6" fill="none" stroke-linecap="round"/>
							<path v-else d="M16 9l5 6M21 9l-5 6" stroke="#FFFFFF" stroke-width="1.6" fill="none" stroke-linecap="round"/>
						</svg>
						</div>
					</div>
					<!-- 底部输入栏的表情选择面板 -->
					<div class="dsp-bar-emoji-panel" v-if="barEmojiShow" @mousedown.stop @click.stop>
						<div class="dsp-bar-emoji-grid">
							<span class="dsp-bar-emoji-item" v-for="(e, ei) in emojiList" :key="ei" @click.stop="pickBarEmoji(e)">{{ e }}</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 评论面板：点击评论按钮才显示 -->
		<div class="dsp-comment" v-if="showComment && currentVideo">
			<div class="dsp-comment-header">
				<span class="dsp-comment-title">{{ currentVideo.commentNumber || 0 }} {{ $t('all.pinglun') }}</span>
				<div class="dsp-comment-close" @click="showComment = false">
					<svg viewBox="0 0 24 24" width="16" height="16">
						<path d="M6 6l12 12M18 6L6 18" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"/>
					</svg>
				</div>
			</div>
			<pinglun ref="pinglun" class="dsp-comment-body" :videoId="currentVideo.id" @count-change="onCommentCountChange"></pinglun>
		</div>
	</div>
</template>

<script>
import { getVideoList, viewUserVideoList, addGiveLikeOrCancelGiveLikeVideo, addCollectOrCancelCollectVideo, commentVideo } from '@/api/user';
// 播放状态快照缓存(组件销毁时保存，重新挂载时恢复)，key: userId|isHost
const playStateCacheMap = new Map();
import kong from '../kong/kong.vue';
import pinglun from '../pinglun/pinglun.vue';
// 右侧操作栏本地图标
import spDz1 from '../../assets/image/sp_dz_1@2x.png';
import spDz2 from '../../assets/image/sp_dz_2@2x.png';
import spPinglun from '../../assets/image/sp_pinglun@2x.png';
import spShoucang1 from '../../assets/image/sp_shoucang@2x.png';
import spShoucang2 from '../../assets/image/sp_shoucang_1@2x.png';
// 暂停时中央播放按钮
import spBf from '../../assets/image/sp_bf_87@2x.png';
export default {
	name: 'duanshippin',
	components: {
		kong,
		pinglun
	},
	props: {
		// 是否查热门(0否,1是)，传''时查询全部
		isHost: {
			type: [String, Number],
			default: ''
		},
		// 传了 userId 则查询该用户的视频列表(viewUserVideoList)
		userId: {
			type: [String, Number],
			default: ''
		},
		// 初始定位的视频id
		videoId: {
			type: [String, Number],
			default: ''
		},
		// 分页大小
		size: {
			type: Number,
			default: 10
		}
	},
	data() {
		return {
			spDz1,
			spDz2,
			spPinglun,
			spShoucang1,
			spShoucang2,
			spBf,
			list: [],
			page: 1,
			hasMore: true,
			isLoading: false,
			loaded: false,
			currentIndex: 0,
			muted: false,
			showComment: false,
			resumeIndex: null,
			startApplied: false,
			leaving: false,
			clickTimer: null,
			refreshLock: false,
			touchStartY: 0,
			// 触屏拖动手势进行中：隐藏中央播放按钮，避免滑动中被暂停的相邻视频闪出按钮
			isTouching: false,
			isDragging: false,
			dragStartY: 0,
			dragStartTop: 0,
			dragMoved: false,
			isSeeking: false,
			seekRect: null,
			snapTimer: null,
			// 松手吸附动画进行中：隐藏中央播放按钮，避免过渡期间闪按钮
			snapAnimating: false,
			snapAnimTimer: null,
			isWheelLock: false,
			// 全屏状态（document 级，不是单个 video 元素）
			isFullscreen: false,
			wheelTarget: -1,
			wheelEndTimer: null,
			wheelUnlockTimer: null,
			// 底部控制条内嵌评论输入
			barInput: '',
			barSubmitting: false,
			barEmojiShow: false,
			emojiList: [
				'😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃',
				'😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😚', '😙',
				'😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔',
				'🤐', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '😌', '😔',
				'😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🥵', '🥶',
				'😵', '🤯', '🤠', '🥳', '😎', '🤓', '🥺', '😢', '😭', '😤',
				'😠', '😡', '🤬', '😱', '😨', '😰', '😥', '😓', '😳', '🥺',
				'👍', '👎', '👌', '✌️', '🤞', '🤟', '🤘', '👏', '🙏', '💪',
				'❤️', '💔', '💕', '💖', '🌹', '🎉', '🔥', '💯', '✨', '🎁',
				'🍺', '☕', '🍉', '⚽', '🏀', '🎮', '💰', '🌙', '⭐', '🌈'
			]
		};
	},
	computed: {
		currentVideo() {
			return this.list.length > 0 ? this.list[this.currentIndex] : null;
		}
	},
	mounted() {
		// 键盘上下键翻页
		window.addEventListener('keydown', this.handleKeydown);
		// 全屏状态变化（ESC 退出 / 其他途径进入）
		document.addEventListener('fullscreenchange', this.onFullscreenChange);
		document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
		// 有同场景的播放快照则恢复现场(继续播放之前的视频)，否则正常拉取列表
		// 带videoId的播放详情页每次都按点击的视频定位，不走快照
		const key = this.cacheKey();
		const cached = this.videoId ? null : playStateCacheMap.get(key);
		if (cached) {
			playStateCacheMap.delete(key);
			this.list = cached.list;
			this.currentIndex = cached.currentIndex;
			this.page = cached.page;
			this.hasMore = cached.hasMore;
			this.muted = cached.muted;
			this.loaded = true;
			this.$nextTick(() => {
				const swiper = this.$refs.swiper;
				if (swiper && cached.scrollTop) swiper.scrollTop = cached.scrollTop;
				const idx = cached.playingIndex;
				if (idx > -1 && this.list[idx]) {
					const el = this.getVideoEl(idx);
					if (el) {
						if (this.list[idx].pTime) {
							try { el.currentTime = this.list[idx].pTime; } catch (e) {}
						}
						el.muted = this.muted;
						const p = el.play();
						if (p && p.catch) p.catch(() => {});
					}
				}
			});
			return;
		}
		this.fetchList(1);
	},
	watch: {
		// 分类(全部/热门)切换时重新加载
		isHost() {
			this.showComment = false;
			this.barInput = '';
			this.barEmojiShow = false;
			this.fetchList(1);
		}
	},
	beforeDestroy() {
		window.removeEventListener('keydown', this.handleKeydown);
		document.removeEventListener('fullscreenchange', this.onFullscreenChange);
		document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
		if (this.clickTimer) {
			clearTimeout(this.clickTimer);
			this.clickTimer = null;
		}
		if (this.snapTimer) {
			clearTimeout(this.snapTimer);
			this.snapTimer = null;
		}
		if (this.snapAnimTimer) {
			clearTimeout(this.snapAnimTimer);
			this.snapAnimTimer = null;
		}
		if (this.wheelEndTimer) {
			clearTimeout(this.wheelEndTimer);
			this.wheelEndTimer = null;
		}
		if (this.wheelUnlockTimer) {
			clearTimeout(this.wheelUnlockTimer);
			this.wheelUnlockTimer = null;
		}
		this.isDragging = false;
		document.body.style.userSelect = '';
		// 销毁期间也隐藏播放按钮，避免暂停导致按钮闪现
		this.leaving = true;
		// 保存播放现场快照，供下次挂载时恢复(播放详情页不保存，每次按点击的视频定位)
		if (!this.videoId) {
			const swiper = this.$refs.swiper;
			playStateCacheMap.set(this.cacheKey(), {
				list: this.list.map(item => ({ ...item, playing: false })),
				currentIndex: this.currentIndex,
				page: this.page,
				hasMore: this.hasMore,
				scrollTop: swiper ? swiper.scrollTop : 0,
				muted: this.muted,
				playingIndex: this.list.findIndex(item => item.playing)
			});
			// 限制缓存数量，避免无限增长
			if (playStateCacheMap.size > 10) {
				const firstKey = playStateCacheMap.keys().next().value;
				playStateCacheMap.delete(firstKey);
			}
		}
		// 停止所有视频播放
		this.list.forEach((item, i) => {
			const el = this.getVideoEl(i);
			if (el) el.pause();
		});
	},
	// keep-alive 离开页面：暂停正在播放的视频并记住位置
	deactivated() {
		// 离开期间隐藏播放按钮，避免暂停导致按钮闪现
		this.leaving = true;
		const idx = this.list.findIndex(item => item.playing);
		if (idx > -1) {
			this.resumeIndex = idx;
			const el = this.getVideoEl(idx);
			if (el) el.pause();
		}
	},
	// keep-alive 返回页面：校准滚动位置并继续播放之前暂停的视频
	activated() {
		this.leaving = false;
		this.$nextTick(() => {
			const swiper = this.$refs.swiper;
			if (swiper && swiper.clientHeight) {
				swiper.scrollTop = this.currentIndex * swiper.clientHeight;
			}
		});
		if (this.resumeIndex === null) return;
		const idx = this.resumeIndex;
		this.resumeIndex = null;
		this.$nextTick(() => {
			const el = this.getVideoEl(idx);
			if (el) {
				el.muted = this.muted;
				const p = el.play();
				if (p && p.catch) p.catch(() => {});
			}
		});
	},
	methods: {
		// 播放快照缓存key：区分首页(全部/热门)与用户视频页场景
		cacheKey() {
			return [this.userId || '', this.isHost === undefined ? '' : this.isHost].join('|');
		},
		// 解析列表接口返回
		parseRows(response) {
			const data = response.data || response;
			return Array.isArray(data) ? data : (data.rows || data.list || []);
		},
		// 解析总条数
		parseTotal(response, fallbackLen) {
			const data = response.data || response;
			return data.total || response.total || fallbackLen || 0;
		},
		// 跳转用户主页
		handleGoUserHome(item) {
			const userId = item.userId || (item.userInfo && item.userInfo.userId);
			if (!userId) return;
			this.$router.push({ path: '/yonghuzhuye', query: { userId: userId } });
		},
		// 补齐本地需要的字段
		formatItem(item) {
			return {
				...item,
				// 兼容不同接口返回的视频id字段名
				id: item.id || item.videoId || item.video_id,
				isGiveLike: item.isGiveLike || 0,
				giveLikeNumber: item.giveLikeNumber || 0,
				isCollect: item.isCollect || 0,
				collectNumber: item.collectNumber || 0,
				commentNumber: item.commentNumber || 0,
				playing: false,
				// 是否正在缓冲等待数据（waiting/playing 事件维护）
				buffering: false,
				pTime: 0,
				dTime: 0
			};
		},
		// 获取视频列表
		async fetchList(page) {
			if (this.isLoading) return;
			this.isLoading = true;
			try {
				const response = await this.fetchPage(page);
				const rows = this.parseRows(response);
				const total = this.parseTotal(response, rows.length);
				this.page = page;
				this.hasMore = page < Math.ceil(total / this.size);
				this.list = rows.map(item => this.formatItem(item));
				this.currentIndex = 0;
				if (this.$refs.swiper) this.$refs.swiper.scrollTop = 0;
				// 初始定位到指定视频：若第1页未找到，继续加载后续页直至定位到目标视频
				if (!this.startApplied && this.videoId) {
					this.startApplied = true;
					let idx = this.list.findIndex(item => String(item.id) === String(this.videoId));
					if (idx < 0) {
						idx = await this.loadMoreUntilFound();
					}
					if (idx > 0) {
						this.currentIndex = idx;
						this.$nextTick(() => {
							const el = this.$refs.swiper;
							if (el && el.clientHeight) el.scrollTop = idx * el.clientHeight;
							this.playCurrent();
						});
						return;
					}
				}
				this.$nextTick(() => {
					this.playCurrent();
				});
			} catch (error) {
				console.error('获取视频列表失败:', error);
			} finally {
				this.isLoading = false;
				this.loaded = true;
			}
		},
		// 加载更多页，直到找到目标 videoId 或没有更多数据，返回目标视频在列表中的下标
		async loadMoreUntilFound() {
			while (this.hasMore) {
				try {
					const nextPage = this.page + 1;
					const response = await this.fetchPage(nextPage);
					const rows = this.parseRows(response);
					const total = this.parseTotal(response, 0);
					if (rows.length === 0) {
						this.hasMore = false;
						break;
					}
					this.page = nextPage;
					this.hasMore = nextPage < Math.ceil(total / this.size);
					const formatted = rows.map(item => this.formatItem(item));
					this.list = [...this.list, ...formatted];
					const idx = this.list.findIndex(item => String(item.id) === String(this.videoId));
					if (idx >= 0) return idx;
				} catch (e) {
					console.error('加载更多视频失败:', e);
					break;
				}
			}
			return -1;
		},
		// 按模式取列表接口：传了 userId 查该用户的视频，否则查平台短影音
		fetchPage(page) {
			if (this.userId) {
				return viewUserVideoList({ page: page, size: this.size, viewUserId: this.userId });
			}
			return getVideoList({ isHost: this.isHost, page: page, size: this.size });
		},
		// 顶部上滑：刷新最新列表
		tryRefresh() {
			if (this.refreshLock || this.isLoading) return;
			this.refreshLock = true;
			this.fetchList(1).finally(() => {
				setTimeout(() => {
					this.refreshLock = false;
				}, 1500);
			});
		},
		// 底部下滑：加载更多
		async loadMore() {
			if (this.isLoading || !this.hasMore || this.list.length === 0) return;
			this.isLoading = true;
			try {
				const nextPage = this.page + 1;
				const response = await this.fetchPage(nextPage);
				const rows = this.parseRows(response);
				const total = this.parseTotal(response, 0);
				if (rows.length === 0) {
					this.hasMore = false;
					return;
				}
				this.page = nextPage;
				this.list = [...this.list, ...rows.map(item => this.formatItem(item))];
				this.hasMore = nextPage < Math.ceil(total / this.size);
			} catch (error) {
				console.error('加载更多视频失败:', error);
			} finally {
				this.isLoading = false;
			}
		},
		// 滚动事件：切换当前视频 / 触底加载更多 / 停止后自动吸附
		handleScroll() {
			const el = this.$refs.swiper;
			if (!el || el.clientHeight === 0 || this.list.length === 0) return;
			// 滚轮翻页动画途中冻结下标更新，避免越过中点提前切页导致一次手势翻两个视频
			if (this.isWheelLock) return;
			const index = Math.round(el.scrollTop / el.clientHeight);
			if (index !== this.currentIndex && index >= 0 && index < this.list.length) {
				this.currentIndex = index;
				this.showComment = false;
				this.barEmojiShow = false;
				this.playCurrent();
			}
			// 最后一个视频触底 → 加载更多
			if (this.currentIndex >= this.list.length - 1 && el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
				this.loadMore();
			}
			// 滚动停止后吸附到最近的视频（拖动中不处理，松手时单独吸附）
			if (this.snapTimer) clearTimeout(this.snapTimer);
			this.snapTimer = setTimeout(() => {
				this.snapTimer = null;
				if (!this.isDragging) this.snapToNearest();
			}, 150);
		},
		// 吸附到最近的视频
		snapToNearest() {
			const el = this.$refs.swiper;
			if (!el || el.clientHeight === 0 || this.list.length === 0) return;
			const index = Math.min(this.list.length - 1, Math.max(0, Math.round(el.scrollTop / el.clientHeight)));
			// 吸附动画期间隐藏中央播放按钮，动画结束后再按真实播放状态显示
			this.snapAnimating = true;
			if (this.snapAnimTimer) clearTimeout(this.snapAnimTimer);
			this.snapAnimTimer = setTimeout(() => {
				this.snapAnimTimer = null;
				this.snapAnimating = false;
			}, 350);
			el.scrollTo({ top: index * el.clientHeight, behavior: 'smooth' });
		},
		// 滚轮：直接翻页（一格一个视频），顶部上滑刷新，底部下滑加载更多
		handleWheel(e) {
			e.preventDefault(); // 接管滚轮，避免自由滚动与吸附打架
			const el = this.$refs.swiper;
			if (!el || this.list.length === 0) return;
			// 触控板惯性事件：锁定期间全部吞掉，并重置“静止检测”计时，等惯性完全停止后再解锁
			if (this.isWheelLock) {
				this.markWheelActive();
				return;
			}
			const deltaY = e.deltaY;
			if (Math.abs(deltaY) < 5) return;
			if (deltaY < 0) {
				// 第一个视频继续上滑 → 刷新最新
				if (this.currentIndex === 0 && el.scrollTop <= 5) {
					this.tryRefresh();
					return;
				}
				this.wheelTo(this.currentIndex - 1);
			} else {
				// 最后一个视频继续下滑 → 加载更多
				if (this.currentIndex >= this.list.length - 1 && el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
					this.loadMore();
					return;
				}
				this.wheelTo(this.currentIndex + 1);
			}
		},
		// 每次滚轮事件都重置静止计时器：触控板惯性会持续派发事件，只有停顿后才算一次手势结束
		markWheelActive() {
			if (this.wheelEndTimer) clearTimeout(this.wheelEndTimer);
			this.wheelEndTimer = setTimeout(() => {
				this.wheelEndTimer = null;
				this.finishWheel();
			}, 260);
		},
		// 惯性停止：校准到目标视频后解锁
		finishWheel() {
			const el = this.$refs.swiper;
			if (el && this.wheelTarget >= 0 && this.wheelTarget < this.list.length) {
				el.scrollTo({ top: this.wheelTarget * el.clientHeight, behavior: 'smooth' });
			}
			if (this.wheelUnlockTimer) clearTimeout(this.wheelUnlockTimer);
			this.wheelUnlockTimer = setTimeout(() => {
				this.wheelUnlockTimer = null;
				this.isWheelLock = false;
				this.wheelTarget = -1;
			}, 300);
		},
		// 滚轮翻页到指定视频
		wheelTo(index) {
			const el = this.$refs.swiper;
			if (!el) return;
			if (index < 0 || index > this.list.length - 1) {
				this.snapToNearest(); // 超出边界回弹
				return;
			}
			this.isWheelLock = true;
			this.wheelTarget = index;
			// 立即切到目标下标并播放，后续惯性事件因锁定被吞掉，不会再叠加翻页
			if (this.currentIndex !== index) {
				this.currentIndex = index;
				this.showComment = false;
				this.barEmojiShow = false;
				this.playCurrent();
			}
			el.scrollTo({ top: index * el.clientHeight, behavior: 'smooth' });
			this.markWheelActive();
		},
		// 触摸：顶部下拉刷新
		handleTouchStart(e) {
			this.isTouching = true;
			this.touchStartY = e.touches[0].clientY;
		},
		handleTouchMove(e) {
			const el = this.$refs.swiper;
			if (!el || this.list.length === 0) return;
			const deltaY = e.touches[0].clientY - this.touchStartY;
			if (deltaY > 30 && el.scrollTop <= 0 && this.currentIndex === 0) {
				this.tryRefresh();
			}
		},
		// 触摸结束：吸附到最近的视频
		handleTouchEnd() {
			this.snapToNearest();
			// 等吸附动画结束后再恢复中央播放按钮的正常显示
			setTimeout(() => {
				this.isTouching = false;
			}, 350);
		},
		// 播放当前视频，暂停其它
		playCurrent() {
			this.list.forEach((item, i) => {
				const el = this.getVideoEl(i);
				if (!el) return;
				if (i === this.currentIndex) {
					// src 是按需动态挂载的，切页瞬间新视频可能还没挂上 src，等 DOM 更新后再播
					this.$set(this.list[i], 'buffering', true);
					if (el.getAttribute('src')) {
						this.startCurrentPlay(el, i);
					} else {
						this.$nextTick(() => {
							const cur = this.getVideoEl(i);
							if (cur && i === this.currentIndex) this.startCurrentPlay(cur, i);
						});
					}
				} else {
					el.pause();
					this.$set(this.list[i], 'playing', false);
				}
			});
		},
		// 播放指定下标的当前视频（含自动播放被拦截时的静音重试）
		startCurrentPlay(el, i) {
			const item = this.list[i];
			if (!item) return;
			// 兜底：元素被复用(同key同src)时 loadedmetadata 不会重新触发，补记总时长
			if (!item.dTime && el.duration && !isNaN(el.duration)) {
				this.$set(item, 'dTime', el.duration);
			}
			// 严格跟随用户最后一次显式设置的 muted 状态，自动播放拦截只做临时处理不覆盖全局
			el.muted = this.muted;
			const p = el.play();
			if (p && p.catch) {
				p.catch(() => {
					// 自动播放被浏览器策略拦截（尤其是非静音 + 首次/跨页回到前台），
					// 仅对当前元素临时静音重试，不把用户全局设置 this.muted 改掉
					el.muted = true;
					const p2 = el.play();
					if (p2 && p2.catch) p2.catch(() => {});
				});
			}
			this.$set(item, 'playing', true);
		},
		getVideoEl(i) {
			const ref = this.$refs['video' + i];
			return Array.isArray(ref) ? ref[0] : ref;
		},
		// 只给当前视频及上/下相邻视频挂载地址：
		// 避免一页10个视频同时发起媒体请求抢占带宽导致正在播放的视频卡顿，
		// 相邻视频提前缓冲，滑到下一个视频时基本可直接起播
		videoSrc(item, index) {
			if (Math.abs(index - this.currentIndex) <= 1) return item.videoUrl;
			return null; // 返回 null 时 Vue 会移除 src 属性，只显示 poster 封面
		},
		// 区分单击(播放/暂停)与双击(点赞)
		handleVideoClick(index) {
			// 左键拖动切换视频后，不触发单击播放/暂停
			if (this.dragMoved) {
				this.dragMoved = false;
				return;
			}
			if (this.clickTimer) {
				// 双击的第二次点击，交给 dblclick 处理
				clearTimeout(this.clickTimer);
				this.clickTimer = null;
				return;
			}
			this.clickTimer = setTimeout(() => {
				this.clickTimer = null;
				this.togglePlay(index);
			}, 250);
		},
		// 双击点赞：已点赞时不再触发接口
		handleVideoDblClick(item) {
			if (this.clickTimer) {
				clearTimeout(this.clickTimer);
				this.clickTimer = null;
			}
			if (item.isGiveLike === 1) return;
			this.handleToggleLike(item);
		},
		// 播放进度百分比
		progressPercent(item) {
			if (!item.dTime || isNaN(item.dTime)) return 0;
			return Math.min(100, (item.pTime / item.dTime) * 100);
		},
		// 进度条按下：立即跳转并进入拖动状态
		handleProgressDown(e, index) {
			const el = this.getVideoEl(index);
			if (!el || !el.duration || isNaN(el.duration)) return;
			this.isSeeking = true;
			this.seekRect = e.currentTarget.getBoundingClientRect();
			this.seekVideo(el, index, e.clientX);
			const move = (ev) => {
				if (!this.isSeeking) return;
				this.seekVideo(el, index, ev.clientX);
			};
			const up = () => {
				this.isSeeking = false;
				window.removeEventListener('mousemove', move);
				window.removeEventListener('mouseup', up);
			};
			window.addEventListener('mousemove', move);
			window.addEventListener('mouseup', up);
		},
		// 按横坐标跳转播放进度
		seekVideo(el, index, clientX) {
			if (!this.seekRect || this.seekRect.width === 0) return;
			let ratio = (clientX - this.seekRect.left) / this.seekRect.width;
			ratio = Math.min(1, Math.max(0, ratio));
			el.currentTime = ratio * el.duration;
			this.$set(this.list[index], 'pTime', el.currentTime);
		},
		// 鼠标按住拖动：右键直接拖动；左键移动超过阈值也拖动（与单击/双击区分）
		handleDragDown(e) {
			if (e.button !== 2 && e.button !== 0) return;
			const el = this.$refs.swiper;
			if (!el || this.list.length === 0) return;
			// 打断进行中的平滑吸附动画，避免与拖动冲突
			el.scrollTo({ top: el.scrollTop });
			// 用户主动接管拖动：解除滚轮翻页锁定及惯性检测
			this.isWheelLock = false;
			this.wheelTarget = -1;
			if (this.wheelEndTimer) {
				clearTimeout(this.wheelEndTimer);
				this.wheelEndTimer = null;
			}
			if (this.wheelUnlockTimer) {
				clearTimeout(this.wheelUnlockTimer);
				this.wheelUnlockTimer = null;
			}
			this.isDragging = false;
			this.dragStartY = e.clientY;
			this.dragStartTop = el.scrollTop;
			if (e.button === 0) {
				this.dragMoved = false; // 左键：标记是否发生过拖动，用于抑制误触单击
			}
			const isRight = e.button === 2;
			const threshold = isRight ? 0 : 5;
			const dragFactor = 3; // 拖动加速：拖三分之一屏即可翻页
			const move = (ev) => {
				const dy = ev.clientY - this.dragStartY;
				if (!this.isDragging && Math.abs(dy) <= threshold) return;
				if (!this.isDragging) {
					if (!isRight) this.dragMoved = true;
					this.isDragging = true;
					document.body.style.userSelect = 'none';
				}
				// 向上拖动 → scrollTop 增大（下一个视频），与触屏方向一致
				el.scrollTop = this.dragStartTop - dy * dragFactor;
			};
			const up = () => {
				const wasDragging = this.isDragging;
				this.isDragging = false;
				document.body.style.userSelect = '';
				window.removeEventListener('mousemove', move);
				window.removeEventListener('mouseup', up);
				// 松手后吸附到最近的视频
				if (wasDragging) this.snapToNearest();
			};
			window.addEventListener('mousemove', move);
			window.addEventListener('mouseup', up);
		},
		// 播放/暂停
		togglePlay(index) {
			const el = this.getVideoEl(index);
			if (!el) return;
			if (el.paused) {
				const p = el.play();
				if (p && p.catch) p.catch(() => {});
				this.$set(this.list[index], 'playing', true);
			} else {
				el.pause();
				this.$set(this.list[index], 'playing', false);
			}
		},
		// 静音切换
		toggleMute(index) {
			this.muted = !this.muted;
			const el = this.getVideoEl(index);
			if (el) el.muted = this.muted;
		},
		// 全屏切换：直接对当前 video 元素调原生 Fullscreen API，兼容前缀
		toggleFullscreen() {
			const el = this.getVideoEl(this.currentIndex);
			if (!el) return;
			if (this.isFullscreen) {
				const exit = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
				if (exit) exit.call(document);
			} else {
				const req = el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen;
				if (req) req.call(el);
			}
		},
		// 监听 ESC 等方式退出全屏时同步 isFullscreen
		onFullscreenChange() {
			const fs = document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
			this.isFullscreen = !!fs;
		},
		// 点赞/取消点赞
		async handleToggleLike(item) {
			try {
				await addGiveLikeOrCancelGiveLikeVideo({ videoId: item.id });
				const liked = item.isGiveLike === 1;
				this.$set(item, 'isGiveLike', liked ? 0 : 1);
				this.$set(item, 'giveLikeNumber', Math.max(0, item.giveLikeNumber + (liked ? -1 : 1)));
			} catch (error) {
				console.error('点赞操作失败:', error);
			}
		},
		// 收藏/取消收藏
		async handleToggleCollect(item) {
			try {
				await addCollectOrCancelCollectVideo({ videoId: item.id });
				const collected = item.isCollect === 1;
				this.$set(item, 'isCollect', collected ? 0 : 1);
				this.$set(item, 'collectNumber', Math.max(0, item.collectNumber + (collected ? -1 : 1)));
			} catch (error) {
				console.error('收藏操作失败:', error);
			}
		},
		// 打开评论面板
		handleShowComment(item) {
			this.currentIndex = this.list.indexOf(item);
			this.showComment = true;
		},
		// 键盘 ← ↑ → ↓ / Space：视频上下翻页 + 播放暂停 + 静音切换
		handleKeydown(e) {
			// 输入框 / textarea / contenteditable 聚焦时，让浏览器正常处理（输入文字、方向键移动光标）
			const tag = (e.target && e.target.tagName) || '';
			if (tag === 'INPUT' || tag === 'TEXTAREA' || (e.target && e.target.isContentEditable)) return;
			// 评论面板内输入栏、底部控制条输入框已被上面 INPUT 拦掉，其他键盘事件继续
			if (this.leaving || this.isDragging || this.isTouching || this.snapAnimating) return;
			switch (e.key) {
				case 'ArrowUp':
				case 'ArrowLeft':
				case 'PageUp':
					e.preventDefault();
					if (!this.isWheelLock) this.wheelTo(this.currentIndex - 1);
					break;
				case 'ArrowDown':
				case 'ArrowRight':
				case 'PageDown':
					e.preventDefault();
					if (!this.isWheelLock) this.wheelTo(this.currentIndex + 1);
					break;
				case ' ':
				case 'Spacebar':
					e.preventDefault();
					this.togglePlay(this.currentIndex);
					break;
				case 'm':
				case 'M':
					this.toggleMute(this.currentIndex);
					break;
			}
		},
		// 评论数变化（发表+1 / 删除-1），联动右侧按钮和面板标题
		onCommentCountChange(delta) {
			const item = this.list[this.currentIndex];
			if (item) {
				this.$set(item, 'commentNumber', Math.max((item.commentNumber || 0) + delta, 0));
			}
		},
		// ====== 底部控制条内嵌评论输入 ======
		toggleBarEmoji() {
			this.barEmojiShow = !this.barEmojiShow;
		},
		// 选择表情追加到输入框末尾
		pickBarEmoji(e) {
			this.barInput = (this.barInput || '') + e;
		},
		// 发表评论（与评论面板共用 commentVideo 接口）
		async submitBarComment() {
			const item = this.list[this.currentIndex];
			const content = (this.barInput || '').trim();
			if (!content || this.barSubmitting || !item) return;
			this.barSubmitting = true;
			try {
				const res = await commentVideo({ videoId: item.id, content });
				this.barInput = '';
				this.barEmojiShow = false;
				this.onCommentCountChange(1);
				// 面板已打开时，把新评论立刻塞到 pinglun 列表头部
				if (this.showComment) {
					this.$nextTick(() => {
						const pinglun = this.$refs.pinglun;
						if (!pinglun) return;
						// 优先尝试从接口返回里 pick 出新建对象（与 pinglun 内部 submit 逻辑对齐）
						const created = this.pickCreatedForPinglun(res);
						if (created) {
							pinglun.list.unshift(created);
							pinglun.total = (pinglun.total || 0) + 1;
						} else if (pinglun.resetList) {
							// 拿不到返回对象时走 resetList 兜底（重置 page/hasMore 再重拉第一页）
							pinglun.resetList();
						}
					});
				}
			} catch (e) {
				console.error('评论失败:', e);
			} finally {
				this.barSubmitting = false;
			}
		},
		// 从 commentVideo 接口返回中提取可直接 unshift 到 pinglun.list 的归一化对象
		pickCreatedForPinglun(response) {
			const d = response && response.data;
			if (!d || typeof d !== 'object') return null;
			const cid = d.commentId !== undefined ? d.commentId : d.id;
			if (!cid || !d.content) return null;
			const store = this.$store.state || {};
			return {
				id: cid,
				userId: d.userId || store.userId || '',
				avatar: d.userHeadPortrait || store.userInfo && store.userInfo.headPortrait || '',
				nickName: d.userNickName || store.userInfo && store.userInfo.nickName || '',
				content: d.content,
				createTime: d.createTime || new Date().toISOString().replace('T', ' ').slice(0, 19),
				isPresentUser: 1, // 自己发的
				replyNumber: 0,
				childs: [],
				childPage: 1,
				childHasMore: false,
				childLoading: false
			};
		},
		// 同步真实播放状态（手动暂停/缓冲恢复/系统暂停都准确）
		onVideoPlay(index) {
			if (this.list[index]) this.$set(this.list[index], 'playing', true);
		},
		onVideoPause(index) {
			if (this.list[index]) this.$set(this.list[index], 'playing', false);
		},
		// 缓冲开始：数据跟不上时显示加载圈
		onVideoWaiting(index) {
			if (this.list[index]) this.$set(this.list[index], 'buffering', true);
		},
		// 恢复播放 / 数据就绪：隐藏加载圈
		onVideoPlaying(index) {
			if (this.list[index]) this.$set(this.list[index], 'buffering', false);
		},
		onVideoCanPlay(index) {
			if (this.list[index]) this.$set(this.list[index], 'buffering', false);
		},
		// 记录播放进度
		onTimeUpdate(index) {
			const el = this.getVideoEl(index);
			if (el && index === this.currentIndex) {
				const item = this.list[index];
				if (!item) return;
				// 兜底：总时长缺失时同步（同key元素复用不会再次触发loadedmetadata）
				if (!item.dTime && el.duration && !isNaN(el.duration)) {
					this.$set(item, 'dTime', el.duration);
				}
				this.$set(item, 'pTime', el.currentTime);
			}
		},
		// 记录视频总时长
		onLoadedMetadata(index) {
			const el = this.getVideoEl(index);
			if (el) {
				this.$set(this.list[index], 'dTime', el.duration || 0);
			}
		},
		// 格式化时间
		formatTime(seconds) {
			if (!seconds || isNaN(seconds)) return '00:00';
			const min = Math.floor(seconds / 60);
			const sec = Math.floor(seconds % 60);
			return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
		}
	}
}
</script>

<style scoped lang="scss">
	.dsp-box{
		width: 100%;
		height: 100%;
		position: relative;
		background: #000000;
		overflow: hidden;
	}
	.dsp-swiper{
		width: 100%;
		height: 100%;
		overflow-y: auto;
		-ms-overflow-style: none;
		scrollbar-width: none;
		user-select: none;
		-webkit-user-select: none;
		transition: width 0.25s;
	}
	/* 评论面板打开时，视频区域收窄到左侧并保持居中 */
	.dsp-swiper--narrow{
		width: calc(100% - 350px);
	}
	.dsp-swiper::-webkit-scrollbar{
		display: none;
	}
	.dsp-swiper-item{
		width: 100%;
		height: 100%;
		position: relative;
		background: #000000;
		overflow: hidden;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		padding-bottom: 44px; /* 底部控制条区域不显示视频画面 */
	}
	.dsp-video-wrap{
		flex: 1;
		min-height: 0;
		position: relative;
		overflow: hidden;
		background: #000000;
	}
	/* 视频背后的虚化封面图：铺满整个播放区，视频画面居中叠在其上 */
	.dsp-video-bg{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		filter: blur(30px) brightness(0.6);
		transform: scale(1.15); /* 放大遮住虚化边缘 */
		z-index: 0;
	}
	.dsp-video{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: contain;
		display: block;
		background: transparent; /* 不能设黑色背景，否则会盖住虚化图 */
		z-index: 1;
	}
	/* 暂停时中央播放按钮：纯视觉不挡点击，单击/双击事件仍落在视频上 */
	.dsp-play-btn{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 87px;
		height: 87px;
		z-index: 2;
		pointer-events: none;
	}
	/* 缓冲加载圈：网络跟不上时在画面中央提示 */
	.dsp-loading{
		position: absolute;
		top: 50%;
		left: 50%;
		width: 42px;
		height: 42px;
		margin: -21px 0 0 -21px;
		border: 3px solid rgba(255,255,255,0.25);
		border-top-color: #FFFFFF;
		border-radius: 50%;
		z-index: 2;
		pointer-events: none;
		animation: dsp-spin 0.8s linear infinite;
	}
	@keyframes dsp-spin{
		to{ transform: rotate(360deg); }
	}
	/* 全屏按钮：视频画面右上角 */
	.dsp-fullscreen-btn{
		position: absolute;
		top: 16px;
		right: 16px;
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background: rgba(0,0,0,0.45);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		z-index: 3;
		transition: background 0.2s ease, transform 0.15s ease;
	}
	.dsp-fullscreen-btn:hover{
		background: rgba(0,0,0,0.65);
		transform: scale(1.08);
	}
	.dsp-fullscreen-btn:active{
		transform: scale(0.96);
	}
	.dsp-info{
		position: absolute;
		left: 24px;
		bottom: 64px;
		display: flex;
		flex-direction: column;
		z-index: 2;
		pointer-events: none;
	}
	.dsp-info-user{
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		text-shadow: 0px 1px 4px rgba(0,0,0,0.4);
	}
	.dsp-info-title{
		margin-top: 8px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 18px;
		color: #FFFFFF;
		text-shadow: 0px 1px 4px rgba(0,0,0,0.4);
	}
	.dsp-actions{
		position: absolute;
		right: 24px;
		bottom: 90px;
		display: flex;
		flex-direction: column;
		align-items: center;
		z-index: 2;
	}
	.actions{
		display: flex;
		flex-direction: column;
		padding: 5px;
		background: rgba(0,0,0,0.6);
		border-radius: 27px 27px 27px 27px;
	}
	.dsp-actions-item{
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 20px;
		cursor: pointer;
	}
	.dsp-actions-item1{
		display: flex;
		flex-direction: column;
		align-items: center;
		cursor: pointer;
	}
	.dsp-actions-item:active{
		opacity: 0.8;
	}
	.dsp-actions-icon{
		width: 48px;
		height: 48px;
		border-radius: 50%;
		display: block;
	}
	.dsp-actions-avatar{
		width: 48px;
		height: 48px;
		border-radius: 50%;
		object-fit: cover;
		border: 2px solid #FFFFFF;
	}
	.dsp-actions-avatar-default{
		display: flex;
		align-items: center;
		justify-content: center;
		background: #369AFF;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 20px;
		color: #FFFFFF;
	}
	.dsp-actions-count{
		margin-top: 6px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #FFFFFF;
	}
	/* 播放进度条：位于控制条上方，可点击/拖动跳转 */
	.dsp-progress{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 40px;
		height: 12px;
		display: flex;
		align-items: center;
		cursor: pointer;
		z-index: 2;
	}
	.dsp-progress-track{
		position: relative;
		width: 100%;
		height: 4px;
		background: rgba(255,255,255,0.2);
	}
	.dsp-progress-fill{
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		background: linear-gradient( 95deg, #369AFF 0%, #8200CB 88.07%);
		border-radius: 0 2px 2px 0;
	}
	.dsp-controls{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 44px;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0 16px;
		background: rgba(0,0,0,0.55);
		z-index: 2;
	}
	.dsp-controls-btn{
		width: 28px;
		height: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.dsp-controls-time{
		margin-left: 12px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 13px;
		color: #FFFFFF;
		/* 数字等宽：时间跳动时宽度不变，避免整条控制栏晃动 */
		font-variant-numeric: tabular-nums;
	}
	/* 内嵌评论输入：位于控制条中间居中显示 */
	.dsp-controls-input{
		flex: 0 1 460px;
		min-width: 0;
		display: flex;
		flex-direction: row;
		align-items: center;
		height: 30px;
		margin: 0 auto;
		padding: 0 4px 0 8px;
		background: rgba(255,255,255,0.12);
		border-radius: 15px;
		box-sizing: border-box;
	}
	/* 静音按钮贴右侧 */
	.dsp-controls-btn:last-child{
		margin-left: 0;
	}
	.dsp-bar-emoji-btn{
		padding: 3px;
		flex-shrink: 0;
		cursor: pointer;
		display: flex;
		align-items: center;
	}
	.dsp-bar-emoji-face{
		position: relative;
		width: 16px;
		height: 16px;
		border: 1.5px solid rgba(255,255,255,0.9);
		border-radius: 50%;
		box-sizing: border-box;
	}
	.dsp-bar-emoji-face::before{
		content: '';
		position: absolute;
		top: 3.5px;
		left: 3.5px;
		width: 1.6px;
		height: 3px;
		background: rgba(255,255,255,0.9);
		border-radius: 1px;
		box-shadow: 5.5px 0 0 rgba(255,255,255,0.9);
	}
	.dsp-bar-emoji-face::after{
		content: '';
		position: absolute;
		left: 2.5px;
		bottom: 2px;
		width: 8px;
		height: 4px;
		border: 1.5px solid rgba(255,255,255,0.9);
		border-top: none;
		border-left-color: transparent;
		border-right-color: transparent;
		border-radius: 0 0 8px 8px;
		box-sizing: border-box;
	}
	.dsp-bar-emoji-face--active{
		border-color: #369AFF;
	}
	.dsp-bar-emoji-face--active::before{
		background: #369AFF;
		box-shadow: 5.5px 0 0 #369AFF;
	}
	.dsp-bar-emoji-face--active::after{
		border-bottom-color: #369AFF;
	}
	.dsp-controls-field{
		flex: 1;
		min-width: 0;
		height: 100%;
		margin-left: 4px;
		background: transparent;
		border: none;
		outline: none;
		color: #FFFFFF;
		font-size: 12px;
		/* 外层swiper禁用了文本选择，输入框需要恢复 */
		user-select: text;
		-webkit-user-select: text;
	}
	.dsp-controls-field::placeholder{
		color: rgba(255,255,255,0.35);
		font-size: 12px;
	}
	.dsp-controls-send{
		margin-left: 6px;
		padding: 0 14px;
		height: 22px;
		line-height: 22px;
		background: rgba(255,255,255,0.14);
		border: 1px solid rgba(255,255,255,0.2);
		border-radius: 11px;
		color: #FFFFFF;
		font-size: 12px;
		cursor: pointer;
		flex-shrink: 0;
		box-sizing: border-box;
	}
	.dsp-controls-send--loading{
		opacity: 0.6;
	}
	/* 底部输入栏的表情选择面板：悬于控制条上方 */
	.dsp-bar-emoji-panel{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 44px;
		height: 180px;
		background: rgba(20,21,30,0.96);
		z-index: 3;
		overflow-y: auto;
		scrollbar-width: none;
		-ms-overflow-style: none;
	}
	.dsp-bar-emoji-panel::-webkit-scrollbar{
		display: none;
	}
	.dsp-bar-emoji-grid{
		display: flex;
		flex-wrap: wrap;
		padding: 6px 0;
	}
	.dsp-bar-emoji-item{
		width: 10%;
		height: 34px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
		line-height: 1;
		cursor: pointer;
	}
	/* 评论面板：点击评论按钮才显示 */
	.dsp-comment{
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		width: 350px;
		background: #1E1F2B;
		z-index: 10;
		display: flex;
		flex-direction: column;
		border-radius: 12px 0 0 12px;
	}
	.dsp-comment-header{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 14px 16px;
		border-bottom: 1px solid rgba(255,255,255,0.08);
	}
	.dsp-comment-title{
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
	}
	.dsp-comment-close{
		width: 24px;
		height: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.dsp-comment-body{
		flex: 1;
		overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// duanshippin.vue?e08c427a